export default "__VITE_ASSET__CNKerhl4__"